import { RLearningContentProvider } from './remote.gen';
import { Provider, ProviderList } from '@/store/providers';

export function providerTitle(provider: RLearningContentProvider): string {
  switch (provider) {
    case RLearningContentProvider.Coursera:
      return 'Coursera';
    case RLearningContentProvider.Linkedin:
      return 'LinkedIn Learning';
    case RLearningContentProvider.Pluralsight:
      return 'Pluralsight';
    case RLearningContentProvider.Finanskompetens:
      return 'Finanskompetens';
    case RLearningContentProvider.Imparta:
      return 'Imparta';
    case RLearningContentProvider.Learnifier:
      return 'Learnifier';
    case RLearningContentProvider.Collegial:
      return 'Collegial';
    case RLearningContentProvider.CombientTwin:
      return 'Combient Twin';
    default:
      return provider;
  }
}

const remoteToLocalProviderMap: Partial<Record<RLearningContentProvider, Provider>> = {
  [RLearningContentProvider.Collegial]: ProviderList.COLLEGIAL,
  [RLearningContentProvider.CombientTwin]: ProviderList.COMBIENT_TWIN,
  [RLearningContentProvider.Coursera]: ProviderList.COURSERA,
  [RLearningContentProvider.Finanskompetens]: ProviderList.FINANSKOMPETENS,
  [RLearningContentProvider.Imd]: ProviderList.IMD,
  [RLearningContentProvider.Imparta]: ProviderList.IMPARTA,
  [RLearningContentProvider.Learnifier]: ProviderList.LEARNIFIER,
  [RLearningContentProvider.Linkedin]: ProviderList.LINKEDIN,
  [RLearningContentProvider.Pluralsight]: ProviderList.PLURALSIGHT,
  [RLearningContentProvider.Udacity]: ProviderList.UDACITY,
  // 'LUMESSE' doesn't have provider in local type, so we don't need to map it
  // 'CUSTOM_LINK' is not used in local type, so we don't need to map it
};

export const getLocalProviderFromRemoteProvider = (provider: RLearningContentProvider): Provider | undefined => {
  return remoteToLocalProviderMap[provider];
};
